export enum POSTHOG_EVENT {
  VERIFY_EMAIL_BUTTON_CLICKED = "verify_email_button_clicked",
  DOWNLOAD_AFTERSHOOT_CTA_CLICKED = "download_aftershoot_cta_clicked",
  AUTO_DOWNLOAD_TRIGGER = "auto_download_trigger",
  JOIN_FACEBOOK_CTA_CLICKED = "join_facebook_cta_clicked",
  VIDEO_VIEW_IN_CAROUSEL = "video_viewed_in_carousel",
  UPGRADE_TO_PRO_CTA_CLICKED = "upgrade_to_pro_button_clicked",
  PROFILE_PIC_EDIT_CLICKED = "profile_pic_edit_clicked",
  USERNAME_EDIT_CTA_CLICKED = "username_edit_cta_clicked",
  LAND_ON_REFERRAL_PAGE = "land_on_Referral_Page",
  PAGE_SCROLLED = "Page_Scrolled",
  REFERRAL_INVITE_FAILURE = "referral_invite_failure",
  REFERRAL_INVITE_SUCCESS = "referral_invite_success",
  REFERRAL_INVITE_SENT = "Referral_invite_sent",
  REFERRAL_LINK_COPIED = "referral_Link_Copied",
  REFERRAL_CODE_COPIED = "referral_Code_Copied",
  REFERRAL_LINK_SHARED = "referral_Link_Shared",
  EMAIL_ADDED = "Email_Added",
  GET_AFTERSHOOT_PLAN_BUTTON_CLICKED = "get_aftershoot_plan-button_clicked",
  TAB_SWITCH_TO = "Tab_Switched_to",
  REDEEM_NOW_CTA_CLICKED = "redeem_now_clicked",
  FAQ_CLICKED = "faq_clicked",
  CANCELLATION_FLOW_STARTED = "cancellation_flow_started",
  REASON_SELECTED = "reason_selected",
  KEEP_CURRENT_PLAN_BUTTON_CLICKED = "keep_current_plan_button_clicked",
  CONTEXTUAL_OPTION_CLICKED = "contextual_option_clicked",
  CANCEL_SUBSCRIPTION_CONFIRMED = "Land on the cancel subscription confirmed page",
  CONTINUE_TO_CANCEL_ONE = "continue_to_cancel_step_one",
  OPTION_SELECTED = "option_selected",
  BOOK_CALL_CLICKED = "book_call_clicked",
  TALK_TO_EXPERTS_CLICKED = "talk_to_experts_clicked",
  COOKING_CARD_CLICKED = "cooking_card_clicked",
  FEATURES_CARD_CLICKED = "features_card_clicked",
  NEED_ASSISTANCE_CLICKED = "need_assistance_clicked",
  TECHNICAL_ISSUES_CLICKED = "technical_issues_clicked",
  MISSING_FEATURES_CLICKED = "missing_features_clicked",
  AI_QUALITY_CONCERNS_CLICKED = "ai_quality_concerns_clicked",
  OTHER_REASONS_CLICKED = "other_reasons_clicked",
  JOIN_BETA_CLICKED = "join_beta_clicked",
  REROUTED_TO_REVIEW = "rerouted_to_review_page",

  EMAIL_VERIFICATION = "sent_email_verification",
  REQUEST_PASSWORD_RESET = "request_password_reset",

  USER_SIGNED_UP = "User Signed Up",
  CARD_ADDED_IN_SIGNUP_FLOW = "Card Added in Signup Flow",
  CARD_SKIPPED_IN_SIGNUP_FLOW = "Card Skipped in Signup Flow",
  USER_TRY_REDOWNLOAD = "User Try ReDownload",
  CANCEL_SUBSCRIPTION_CLICKED = "Cancel Subscription Clicked",
  CANCEL_TRIAL_CLICKED = "Cancel Trial Clicked",
  MANAGE_SUBSCRIPTION_CLICKED = "Manage Subscription Clicked",
  ROUTE_ERROR_BOUNDARY_TRIGGERED = "error_boundary_triggered",
}
